var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmllTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#155C8F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(5 5)",
    fill: "#155C8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5343 7.6142C15.7474 7.84027 15.7368 8.19627 15.5108 8.40934L9.56342 14.0148C9.31122 14.2525 8.91531 14.2452 8.67207 13.9983L6.66182 11.958C6.44378 11.7367 6.44642 11.3806 6.66771 11.1626C6.889 10.9445 7.24515 10.9472 7.46318 11.1684L9.13879 12.8691L14.7392 7.59066C14.9652 7.37758 15.3213 7.38812 15.5343 7.6142Z",
    fill: "#E8EFF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmllTick);
export default __webpack_public_path__ + "static/media/SmllTick.e8c0598f358342b4ff8c4c511e0e9a49.svg";
export { ForwardRef as ReactComponent };